import { useState } from "react";
import { MFAContainer, VerifyPinField } from "./utils";
import apiAgent from "../../api/apiAgent";
import { mergeClass, pause } from "../../utils";
import { tMsg } from "../ToastNotifications";
import _ from "lodash";
import { useNavigate } from "react-router";
import { useSetAtom } from "jotai";
import { loginStatusAtom } from "../../atoms";
import { Loader, Spinner } from "../Loader";

export const ValidatePage = ({ username }: { username: string }) => {
  const [validating, setValidating] = useState<boolean>(false);
  const [validateError, setValidateError] = useState<string>("");
  const setLoginStatus = useSetAtom(loginStatusAtom);
  const navigate = useNavigate();

  const activateCode = async (code: string) => {
    try {
      setValidating(true);
      setValidateError("");
      const response = await apiAgent.Auth.verifyMFA(_.toNumber(code), false);
      if (response.status === 202 || response.status === 200) {
        tMsg.success("2FA Successfully validated. Login successful.");
        setLoginStatus(true);
        await pause(700);
        navigate("/");
      }
    } catch (err: any) {
      if (err.response.status === 401) {
        setValidateError("Invalid code");
      }
      if (err.response.status === 403) {
        setValidateError("Code expired, please try again.");
      }
    } finally {
      setValidating(false);
    }
  };

  return (
    <MFAContainer className="">
      <div className="w-1 h-3" />
      <VerifyPinField
        username={username}
        onComplete={activateCode}
        validating={validating}
      />
      <div
        className={mergeClass("h-4 w-full text-center pb-9 text-sm font-bold", {
          "text-red-600": !validating,
        })}
      >
        {validating ? <Spinner /> : validateError}
      </div>
    </MFAContainer>
  );
};
